let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jTear")).then(() => parcelRequire('2Eg1T'));